import { DropdownInput } from "@/frontend/shared/ui/DropdownInput";
import styles from "./LocationsSelector.module.scss";
import { Typography } from "@/frontend/shared/ui/Typography/Typography";
import { ChangeEvent, useEffect, useState } from "react";
import { Tag } from "@/frontend/shared/ui/TagV2";
import { LocationIcon } from "@/frontend/shared/assets/icons/LocationIcon";
import { CaretDownIcon } from "@/frontend/shared/assets/icons";
import { Location2Icon } from "@/frontend/shared/assets/icons/Location2Icon";
import clsx from "clsx";

export type TLocationsSelectorProps = {
  selectedLocation: string;
  setSelectedLocation: (value: string) => void;
  locationOptions: string[];
  locationsTags: string[];
  setLocationsTags: (
    value: { locationsTags: string[] } | ((prev: { locationsTags: string[] }) => { locationsTags: string[] })
  ) => void;
  placeholder?: string;
};

export function LocationsSelector({
  selectedLocation,
  setSelectedLocation,
  locationOptions,
  locationsTags,
  setLocationsTags,
  placeholder
}: TLocationsSelectorProps) {
  const newOptionsWithoutTags = locationOptions
    ?.filter((option) => !locationsTags?.includes(option) && option !== selectedLocation)
    ?.map((option) => ({ label: option, value: option }));

  function onCloseTags(index: number) {
    setLocationsTags((prev) => ({
      ...prev,
      locationsTags: prev.locationsTags?.filter((_, i) => i !== index)
    }));
  }

  function onSelectOption(selected: string) {
    if (!locationsTags.includes(selected)) {
      setLocationsTags((prev) => ({ ...prev, locationsTags: [...prev.locationsTags, selected] }));
      setSelectedLocation("");
    }
  }

  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div className={styles.block}>
      <div className={styles.titleContainer}>
        <div className={styles.title}>
          <Location2Icon />
          <Typography variant="label-4" color="greyscale900">
            Location
          </Typography>
        </div>
        <CaretDownIcon
          onClick={() => setIsCollapsed((prev) => !prev)}
          className={clsx(styles.caretDownIcon, isCollapsed && styles.rotatedIcon)}
        />
      </div>
      {!isCollapsed && (
        <>
          <DropdownInput
            value={selectedLocation}
            options={newOptionsWithoutTags}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setSelectedLocation(e.target.value)}
            onSelect={(selected: string) => {
              onSelectOption(selected);
            }}
            isOpen={!!selectedLocation}
            onClose={() => setSelectedLocation("")}
            placeholder={placeholder}
          />
          <div className={styles.subBlockTags}>
            {locationsTags?.map((tag: string, index) => (
              <div key={index} className={styles.tag}>
                <Tag onClose={() => onCloseTags(index)}>{tag}</Tag>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
